import React from 'react';

import CountryItemWithCode from './CountryItemWithCode';
import CountryLetterItem from '../components/CountryItemPanel/CountryLetterItem';
import CountryItem from '../CountryItem';

const FullCountryList = (props) => {
    const getFirstLetter = (name) => {
        return name ? name.charAt(0) : null;
    };

    if (Array.isArray(props.countries) && props.countries.length > 0) {
        let firstLetter = '';
        return (
            <>
                {props.countries.map((country) => {
                    const key = `countryList_${country.code}`;
                    if (props.hideLetter || firstLetter === getFirstLetter(country.name)) {
                        if (props.countryWithCode) {
                            return (
                                <CountryItemWithCode
                                    key={key}
                                    country={country}
                                    iso2={props.iso2}
                                    onCountryItemClick={props.onCountryItemClick}
                                    isRequest={props.isRequest}
                                    query={props.query}
                                />
                            );
                        } else {
                            return (
                                <CountryItem
                                    key={key}
                                    gotIt={props.gotIt}
                                    userCountry={props.userCountry}
                                    notificationText={props.notificationText}
                                    country={country}
                                    recipientType={props.recipientType}
                                    sendUrIPrefix={props.sendUrIPrefix}
                                    sendUriPostfix={props.sendUriPostfix}
                                    onCountryItemClick={props.onCountryItemClick}
                                    ccyField={props.ccyField}
                                    showCurrency={props.showCurrency}
                                    isLongPanel
                                    query={props.query}
                                    getSelectedCountry={props.getSelectedCountry}
                                    sendBrazeEvent={props.sendBrazeEvent}
                                />
                            );
                        }
                    } else {
                        firstLetter = getFirstLetter(country.name);
                        return (
                            <React.Fragment key={key}>
                                <CountryLetterItem letter={firstLetter} />
                                {props.countryWithCode && (
                                    <CountryItemWithCode
                                        country={country}
                                        iso2={props.iso2}
                                        onCountryItemClick={props.onCountryItemClick}
                                        isRequest={props.isRequest}
                                        query={props.query}
                                    />
                                )}
                                {!props.countryWithCode && (
                                    <CountryItem
                                        country={country}
                                        gotIt={props.gotIt}
                                        userCountry={props.userCountry}
                                        notificationText={props.notificationText}
                                        recipientType={props.recipientType}
                                        sendUrIPrefix={props.sendUrIPrefix}
                                        sendUriPostfix={props.sendUriPostfix}
                                        onCountryItemClick={props.onCountryItemClick}
                                        ccyField={props.ccyField}
                                        showCurrency={props.showCurrency}
                                        isLongPanel
                                        query={props.query}
                                        getSelectedCountry={props.getSelectedCountry}
                                    />
                                )}
                            </React.Fragment>
                        );
                    }
                })}
            </>
        );
    } else {
        return false;
    }
};

export default FullCountryList;
